import { HttpMethodEnum } from '@ipevo-rd/service-web-utils'
import { adminHttpClient } from './client.js'
import type { CommentedRating } from './dto.js'

/**
 * 共用的觀眾報表查詢（/v1/viewers/report/:channelId）
 * @param channelId 頻道 id
 * @param type 報表型別（language / detail_activity / rating）
 * @param startDate 起始時間字串（可選）
 * @param endDate 結束時間字串（可選）
 * @returns 對應型別的報表資料
 */
const fetchViewerReport = async <T>(
	channelId: string,
	type: string,
	startDate: string | undefined,
	endDate: string | undefined,
): Promise<T | undefined> => {
	// 組合報表查詢參數
	const params = new URLSearchParams()

	// 帶上報表型別
	params.append('type', type)

	// 有起始日才帶
	if (startDate) {
		params.append('start_date', startDate)
	}

	// 有結束日才帶
	if (endDate) {
		params.append('end_date', endDate)
	}

	// 發送 GET 請求取得報表資料
	const body = await adminHttpClient.request<T>({
		url: `/viewers/report/${channelId}?${params.toString()}`,
		method: HttpMethodEnum.GET,
	})

	// 回傳對應型別的報表資料
	return body.data
}

/**
 * 取得評分結果報表（type=rating）
 * @param channelId 頻道 id
 * @param startDate 起始時間字串（可選）
 * @param endDate 結束時間字串（可選）
 * @returns 評分結果報表資料
 */
export const getCommentedRating = (
	channelId: string,
	startDate?: string,
	endDate?: string,
) =>
	// 以 rating 型別查詢觀眾報表
	fetchViewerReport<CommentedRating>(channelId, 'rating', startDate, endDate)
